import { render, staticRenderFns } from "./ProfessionInterested.vue?vue&type=template&id=610ef2e5&scoped=true&"
import script from "./ProfessionInterested.vue?vue&type=script&lang=js&"
export * from "./ProfessionInterested.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610ef2e5",
  null
  
)

export default component.exports